<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card card-light" data-aos="fade-up" data-aos-duration="1800">
        <div class="card-body">
          <h1 class="first-gradient fs-38">Free</h1>
          <h3 class="fs-38">
            $0<small class="fs-21 aonik-light">/month</small>
          </h3>
          <ul>
            <li>Folklore</li>
            <li>Have a family Calendar</li>
            <li>Create a Photo Album</li>
            <li>Bulletin Board</li>
            <li>Create an event</li>
            <li>Organise Polls with family</li>
          </ul>
        </div>
        <div class="card-footer text-center">
          <a class="btn signature-btn transparent btn-block w-100" href="#"
            >Try us out</a
          >
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card" data-aos="fade-up" data-aos-duration="3000">
        <div class="card-body">
          <h3 class="white-gradient fs-38">Premium</h3>
          <h3 class="fs-38">
            $100<small class="fs-21 aonik-light">/month</small>
          </h3>
          <ul>
            <li>Folklore</li>
            <li>Have a family Calendar</li>
            <li>Create a Photo Album</li>
            <li>Bulletin Board</li>
            <li>Create an event</li>
            <li>Organise Polls with family</li>
            <li>Introduce a descendant</li>
          </ul>
        </div>
        <div class="card-footer text-center">
          <a class="btn signature-btn btn-block w-100" href="#">Get Started</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: 'Packages',
}
</script>

<style>
</style>